export default "__VITE_ASSET__BZ3HCyHn__"